import React, { ReactNode, useState } from 'react';
import { LinkAsButton } from '@printdeal/ui-library';
import { FormattedMessage } from 'react-intl';
import { Address } from '@printdeal/address-frontend/types';
import OrderAddressContent from '../LineItemShipping/new/OrderAddressContent';
import { SanitizedOrder } from '../../../../../types/order/Order';
import BillingAddressModal from './BillingAddressModal';
import { dispatchAccountEvent } from '../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';

interface Props {
  order: SanitizedOrder;
  canChangeBillingAddress: boolean;
  onChangeSuccess: () => void;
  children: ({ billingAddress, changeBillingAddressButton }: {
    billingAddress: ReactNode,
    changeBillingAddressButton: ReactNode,
  }) => ReactNode;
}

const BillingAddressOnOrderNew = ({
  order,
  canChangeBillingAddress,
  onChangeSuccess,
  children,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  return children({
    billingAddress: (
      <OrderAddressContent address={order.billingAddress as Address} showEmail />
    ),
    changeBillingAddressButton: canChangeBillingAddress ? (
      <>
        <LinkAsButton
          variant="secondary"
          iconBefore="edit"
          className="pd-text-xs"
          data-cy="changeBillingAddressButton"
          onClick={() => {
            setIsModalOpen(true);
            dispatchAccountEvent('order_detail_interaction', 'open_edit_billing_address');
          }}
        >
          <FormattedMessage id="address.button.changeBillingAddress" defaultMessage="Change billing address" />
        </LinkAsButton>

        <BillingAddressModal
          orderId={order.id}
          isOpen={isModalOpen}
          onChangeSuccess={() => {
            onChangeSuccess();
            setIsModalOpen(false);
          }}
          onClose={() => setIsModalOpen(false)}
        />
      </>
    ) : null,
  });
};

export default BillingAddressOnOrderNew;
